
  import { defineComponent } from 'vue';
  import { Tooltip } from '@/ui/components/Tooltip';

  interface ActionButtonProps {
    containsAction: boolean;
    classes: string | Record<string, boolean>;
    disabled: boolean;
  }

  export default defineComponent<ActionButtonProps>({
    components: {
      Tooltip,
    },
    props: ['containsAction', 'classes', 'disabled'],
    emits: ['click'],
  });
